import { AspectRatio, Box } from '@bpba/ui-components';
import { SlideInfo } from './SlideInfo';
import { Evento } from '../../types/Evento';
import { StyledImg } from '../shared/StyledImg';

export const Slide = (props: { evento: Evento }) => {
  if (!props || !props.evento) return <></>;

  return (
    <Box width={'100%'} height={['400px']}>
      <AspectRatio ratio={1.5}>
        <StyledImg
          borderRadius={['8px 32px 8px 32px']}
          alt="slide"
          src={props.evento.imagen}
          objectPosition={'left'}
          height="100% !important"
        />
        <SlideInfo titulo={props.evento.titulo} subtitulo={props.evento.subtitulo} />
      </AspectRatio>
    </Box>
  );
};
